$(document).ready(function () {

  const sliderArrow = `<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" 
                            viewBox="0 0 185.343 185.343" style="enable-background:new 0 0 185.343 185.343;" xml:space="preserve">
                            <g>
                            \t<path style="fill:#010002;" d="M51.707,185.343c-2.741,0-5.493-1.044-7.593-3.149c-4.194-4.194-4.194-10.981,0-15.175
                            \t\tl74.352-74.347L44.114,18.32c-4.194-4.194-4.194-10.987,0-15.175c4.194-4.194,10.987-4.194,15.18,0l81.934,81.934
                            \t\tc4.194,4.194,4.194,10.987,0,15.175l-81.934,81.939C57.201,184.293,54.454,185.343,51.707,185.343z"/>
                            </g>
                            </svg>`;

  var $productsSlider = $('#products-slider__wrapper');

  $productsSlider.slick({
    dots: false,
    arrows: $productsSlider.attr('data-arrows') == 'true' ? true : false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    adaptiveHeight: false,
    swipeToSlide: true,
    prevArrow: '<button class="slick-arrow slick-prev promo-arrows" aria-label="Previous">' + sliderArrow + '</button>',
    nextArrow: '<button class="slick-arrow slick-next promo-arrows" aria-label="Next">' + sliderArrow + '</button>',
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
        }
      }
    ]
  });

  $(document).on('click', '.product-card .color-swatch__radio', function (event) {
    let cardItem = $(this).closest('.product-card-swatch__wrapper');
    let element = {
      card: cardItem,
      cardLink: $(cardItem).find('.product-card__link'),
      cardMainImage: $(cardItem).find('.grid-view-item__image'),
      cardHoverImage: $(cardItem).find('.grid-view-item__image-secondary'),
      colorSwatchValue: $(this).val(),
      colorSwatchVariant: $(this).data(),
      swatchTitle: $(cardItem).find('.grid-view-item__color-title'),
      productPriceBlock: $(cardItem).find('.price--listing'),
      productRegularPrice: $(cardItem).find('.price-item--regular'),
      productComparePrice: $(cardItem).find('.price-item--sale')
    }

    element.cardLink.attr('href', element.colorSwatchVariant.url);
    element.cardLink.attr('href', element.colorSwatchVariant.url);
    element.swatchTitle.text(element.colorSwatchValue);

    if (element.colorSwatchVariant.price < element.colorSwatchVariant.compareAtPrice) {
      element.productPriceBlock.addClass('price--on-sale');
      element.productComparePrice.text(element.colorSwatchVariant.price);
      element.productRegularPrice.text(element.colorSwatchVariant.compareAtPrice);
    } else {
      element.productPriceBlock.removeClass('price--on-sale');
      element.productRegularPrice.text(element.colorSwatchVariant.price);
    }

    if (element.cardMainImage.attr('src') !== element.colorSwatchVariant.imageSrc && element.colorSwatchVariant.type === 'meta') {
      let newMainImage = ($('<img class="grid-view-item__image lazyload"' +
        'id="'+element.colorSwatchVariant.id+'" ' +
        'alt="'+element.colorSwatchVariant.imageAlt+'" ' +
        'data-aspectratio="'+element.colorSwatchVariant.imageRatio+'" ' +
        'data-src="'+element.colorSwatchVariant.imageSrc+'" ' +
        'data-srcset="'+element.colorSwatchVariant.imageSrcset+'"' +
        'data-sizes="auto">'
      ));
      element.cardMainImage.replaceWith(newMainImage);
    } else if (element.cardMainImage.attr('src') !== element.colorSwatchVariant.imageSrc) {
      let newMainImage = ($('<img id="'+element.colorSwatchVariant.id+'" ' +
        'class="grid-view-item__image lazyload" ' +
        'alt="'+element.colorSwatchVariant.imageAlt+'" ' +
        'data-src="'+element.colorSwatchVariant.imageUrl+'" ' +
        'data-widths="['+element.colorSwatchVariant.imageWidth+']" ' +
        'data-aspectratio="'+element.colorSwatchVariant.imageRatio+'" ' +
        'data-sizes="auto">'
      ));
      element.cardMainImage.replaceWith(newMainImage);
    }

    if (element.cardHoverImage.attr('src') !== element.colorSwatchVariant.hoverImageSrc) {
      let newHoverImage = ($('<img class="grid-view-item__image-secondary lazyload"' +
        'alt="'+element.colorSwatchVariant.hoverImageAlt+'" ' +
        'data-aspectratio="'+element.colorSwatchVariant.hoverImageRatio+'" ' +
        'data-src="'+element.colorSwatchVariant.hoverImageSrc+'" ' +
        'data-srcset="'+element.colorSwatchVariant.hoverImageSrcset+'"' +
        'data-sizes="auto">'
      ));
      element.cardHoverImage.replaceWith(newHoverImage);
    }
  })

  //------PDP sliders
  var selectors = {
    productSliderMain: '',
    productSliderThumbs: '',
    productSlidersWrapper: '',
    productSlidersFeaturedMain: '',
    productSlidersFeaturedThumbs: ''
  };

  var slidesToShowThumbs = $(selectors.productSliderThumbs).attr('data-media-size'),
      slidesToShowFeaturedThumbs = $(selectors.productSlidersFeaturedThumbs).attr('data-media-size');

  function sliderInit() {
     selectors = {
      productSliderMain: '.product-slider-single:not(.section-featured-slider)',
      productSliderThumbs: '.product-slider-nav:not(.section-featured-slider)',
      productSlidersWrapper: '.product-slider-content',
      productSlidersFeaturedMain: '.product-slider-single.section-featured-slider',
      productSlidersFeaturedThumbs: '.product-slider-nav.section-featured-slider'
    };

       slidesToShowThumbs = $(selectors.productSliderThumbs).attr('data-media-size');
       slidesToShowFeaturedThumbs = $(selectors.productSlidersFeaturedThumbs).attr('data-media-size');

    const navProductSlides = $(selectors.productSliderThumbs).find(".product-slider-nav__item");
    const mainProductSlides = $(selectors.productSliderMain).find(".product-slider-single__item");
    const navProductSlideCurrent = navProductSlides.filter('.slick-current');

    if (window.innerWidth <= 749) {
      if (!$(selectors.productSliderMain).hasClass("slick-initialized")) {
        sliderMain(selectors.productSliderMain, false, selectors.productSliderThumbs);
      }

      if(!$(selectors.productSliderThumbs).hasClass("slick-initialized")) {
        sliderThumbs(selectors.productSliderThumbs, slidesToShowThumbs, selectors.productSliderMain);
      }

      $(selectors.productSliderThumbs).attr('data-desctop', 'false');

      toggleSlidesA11yAttributes(navProductSlides, navProductSlides, slidesToShowThumbs, navProductSlideCurrent);
      hideMainSlidesA11y(mainProductSlides);
    } else {
      if ($(selectors.productSliderMain).hasClass('slick-initialized')) {
        $(selectors.productSliderMain).slick('unslick');
      }

      if ($(selectors.productSliderThumbs).hasClass('slick-initialized')) {
        $(selectors.productSliderThumbs).slick('unslick');
      }

      $(selectors.productSliderThumbs).attr('data-desctop', 'true');

      removeMainProductSlidesA11yAttributes(mainProductSlides);
    }

    if (!$(selectors.productSlidersFeaturedMain).hasClass("slick-initialized")) {
      sliderMain(selectors.productSlidersFeaturedMain, false, selectors.productSlidersFeaturedThumbs);
    }

    if (!$(selectors.productSlidersFeaturedThumbs).hasClass("slick-initialized")) {
      sliderThumbs(selectors.productSlidersFeaturedThumbs, slidesToShowFeaturedThumbs, selectors.productSlidersFeaturedMain);
    }

    const navFeaturedSlides = $(selectors.productSlidersFeaturedThumbs).find(".slick-slide");
    const mainFeaturedSlides = $(selectors.productSlidersFeaturedMain).find(".product-slider-single__item");
    const navFeaturedSlideCurrent = navFeaturedSlides.filter('.slick-current');

    toggleSlidesA11yAttributesOnChange();
    toggleSlidesA11yAttributes(selectors.productSlidersFeaturedThumbs, navFeaturedSlides, slidesToShowFeaturedThumbs, navFeaturedSlideCurrent);
    hideMainSlidesA11y(mainFeaturedSlides);
  }

  function removeMainProductSlidesA11yAttributes(mainProductSlides) {
    setTimeout(() => {
      mainProductSlides.each(function(index) {
        $(this).removeAttr("aria-hidden");
        $(this).removeAttr("tabindex");
      });
    }, 300);
  }

  function hideMainSlidesA11y(mainSlides) {
    if (!mainSlides.length) return;

    setTimeout(() => {
      mainSlides.each(function(index) {
        $(this).attr("aria-hidden", true);
        $(this).attr("tabindex", -1);
      });
    }, 300);
  }

  function toggleSlidesA11yAttributesOnChange() {
    $('.product-slider-nav').on('afterChange', function() {

      const navSlides = $(this).find(".slick-slide");
      const mainSlides = $(this).prev().find(".slick-slide");
      const slidesToShow = $(this).attr('data-media-size');
      const currentNavSlide = navSlides.filter('.slick-current');

      hideMainSlidesA11y(mainSlides);
      toggleSlidesA11yAttributes(this, navSlides, slidesToShow, currentNavSlide);
      currentNavSlide.focus();
    });
  }

  function toggleSlidesA11yAttributes(navThumbs, navSlides, slidesToShow, currentNavSlide) {
    if (!currentNavSlide.length) return;

    if ($(navThumbs).hasClass("product-slider-nav--no-swiping")) {
      setTimeout(() => {
        navSlides.each(function(index) {
          $(this).attr("aria-hidden", false);
          $(this).attr("tabindex", 0);
        });
      }, 300);

      return;
    }

    const currentNavSlideIndex = currentNavSlide.index();
    const navSpecifiedSlides = navSlides.slice(currentNavSlideIndex, currentNavSlideIndex + +slidesToShow);

    setTimeout(() => {
      navSlides.each(function(index) {
        $(this).attr("aria-hidden", true);
        $(this).attr("tabindex", -1);
      });

      navSpecifiedSlides.each(function(index) {
        $(this).attr("aria-hidden", false);
        $(this).attr("tabindex", 0);
        $(this).attr("aria-label", `Slide ${$(this).data('slick-index') + 1}`);
      });
    }, 300);
  }

  sliderInit()

  $('body').on(':sliderInit', function (e) {
    sliderInit();
  });

  $(window).on('resize orientationchange', function () {
    sliderInit();
  });

  function sliderMain(productSliderMain, availableArrows, asNavForThumbs) {

    if ($(productSliderMain).hasClass('slick-initialized')) {
      return false;
    } else {
      $(productSliderMain).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: availableArrows,
        touchMove: true,
        adaptiveHeight: false,
        dots: false,
        infinite: true,
        speed: 300,
        swipe: true,
        swipeToSlide: true,
        asNavFor: asNavForThumbs,
        touchThreshold: 20,
        responsive: [
          {
            breakpoint: 749,
            settings: {
              infinite: true,
              dots: false,
              arrows: false,
              swipe: true,
              swipeToSlide: true
            }
          }
        ]
      });
    }
  }

  function sliderThumbs(productSliderThumbs, slidesToShow, asNavForMain) {
    if ($(productSliderThumbs).hasClass('slick-initialized')) {
      return false
    } else {
      $(productSliderThumbs).on('init', function (event, slick) {
        // $(this).find('.slick-current').addClass('is-active');
      }).slick({
        arrows: false,
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        dots: false,
        focusOnSelect: true,
        infinite: true,
        touchMove: true,
        swipe: true,
        swipeToSlide: true,
        touchThreshold: 100,
        asNavFor: asNavForMain,
        speed: 300,
        responsive: [
          {
            breakpoint: 990,
            settings: {
              slidesToShow: slidesToShow,
              slidesToScroll: 1,
              infinite: true,
              touchMove: true,
              swipe: true,
              swipeToSlide: true,
              focusOnSelect: true
            }
          },
          {
            breakpoint: 740,
            settings: {
              slidesToShow: slidesToShow,
              slidesToScroll: 1,
              infinite: true,
              touchMove: true,
              swipe: true,
              swipeToSlide: true,
              focusOnSelect: true
            }
          }]
      });
    }
  }

  //-------------Mobile menu
  selectors = {
    mobileNavIcon: '.site-header__menu',
    mobileNavOpenIcon: 'mobile-nav--open',
    mobileNavCloseIcon: 'mobile-nav--close',
    mobileNavWrapper: '.mobile-nav-wrapper',
    subNavToggleBtn: '.js-toggle-submenu'
  };

  $(selectors.mobileNavIcon).on('click', function (e) {

    if ($(this).hasClass('mobile-nav--open')) {
      $(this).removeClass('mobile-nav--open').addClass(selectors.mobileNavCloseIcon);
      $(selectors.mobileNavWrapper).addClass('js-menu--is-open ');
    } else {
      $(this).removeClass(selectors.mobileNavCloseIcon).addClass('mobile-nav--open');
      $(selectors.mobileNavWrapper).removeClass('js-menu--is-open ');
    }
  });

  $(document).on('mouseup', function (e) {
    const mobileNav = $('.js-mobile-nav-toggle.mobile-nav--close');
    
      if ( mobileNav.length && !$(selectors.mobileNavWrapper).is(e.target) && $(selectors.mobileNavWrapper).has(e.target).length === 0 ) { // и не по его дочерним элементам
        mobileNav.removeClass(selectors.mobileNavCloseIcon).addClass('mobile-nav--open');
        $(selectors.mobileNavWrapper).removeClass('js-menu--is-open ');
  }
  })
  
  $(selectors.subNavToggleBtn).on('click', function (e) {
    var _self =  $(this)

    _self.toggleClass('is-active');

    if(_self.hasClass('is-active')) {
      _self.find('.icon-plus').fadeOut();
    } else {
      _self.find('.icon-plus').fadeIn();
    }
  });


  // PDP Airline Compatibility Modal

  const airlineModalOpener = document.querySelector('.js-airlines-modal-opener');
  const airlineModal = document.querySelector('.js-airlines-modal');
  const airlineModalClose = document.querySelectorAll('.js-airlines-modal-close');
  const airlineModalOverlay = document.querySelector('.js-airlines-modal-overlay');

  if (airlineModalOpener && airlineModal) {
    airlineModalOpener.addEventListener('click', function () {
      airlineModal.setAttribute('aria-hidden', 'false');
      airlineModalOverlay.setAttribute('aria-hidden', 'false');
      bodyScrollLock.disableBodyScroll(airlineModal);
    })
  }

  if (airlineModalClose.length && airlineModal) {
    airlineModalClose.forEach(item => {
      item.addEventListener('click', function () {
        airlineModal.setAttribute('aria-hidden', 'true');
        airlineModalOverlay.setAttribute('aria-hidden', 'true');
        bodyScrollLock.clearAllBodyScrollLocks();
      })
    })
  }

  // Compare Suitcases Dropdown
  class suitcaseDropdoown extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('.form-select__btn');
      this.buttonText = this.button.querySelector('.form-select__btn-text');
      this.list = this.querySelector('.form-select__dropdown');
      this.table = this.closest("table");

      this.button.addEventListener('click', (e) => {
        this.button.getAttribute('aria-expanded') === 'true' ? this.close() : this.open();
      });

      this.addEventListener("focusout", function (event) {
        if (this.contains(event.relatedTarget) || !document.hasFocus() ) {
          return;
        }
        this.close();
      });

      this.initOptions();

      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          this.close()
        }
      });
    }

    open() {
      this.button.setAttribute('aria-expanded', 'true');
      $(this.list).slideDown();
    }

    close() {
      this.button.setAttribute('aria-expanded', 'false');
      $(this.list).slideUp();
    }

    initOptions() {
      this.options = this.querySelectorAll('.form-select__dropdown-option');

      this.options.forEach(option => {
        const callback = (e) => {
          let clickedOption = e.target

          if (!e.target.classList.contains('.form-select__dropdown-option')) {
            clickedOption = e.target.closest('.form-select__dropdown-option');
          }

          const value = clickedOption.getAttribute('data-option-value');
          this.close();
          if (clickedOption.getAttribute('aria-selected') === 'true') return;

          this.options.forEach(option => option.setAttribute('aria-selected', 'false'));
          clickedOption.setAttribute('aria-selected', 'true');
          this.buttonText.innerHTML = clickedOption.innerHTML;
          if (value && this.table) {
            this.table.querySelectorAll(`.dropdown-column:not(.${value})`).forEach(item => item.style.display = "none");
            this.table.querySelectorAll(`.dropdown-column.${value}`).forEach(item => item.style.display = "table-cell");
          }
          this.button.setAttribute('aria-selected', 'true');
        };

        option.addEventListener('click', callback);
      })
    }
  }

  customElements.define('suitcase-dropdoown', suitcaseDropdoown);

});
